export const nutritionData = [
  // --- SALGADOS ---
  {
    id: "bolinha-calabresa-queijo",
    category: "Salgados",
    product: "Calabresa com Queijo",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, requeijão, calabresa, farinha de rosca, margarina, queijo mussarela, cebola, sal, caldo de galinha, limão, cebola em pó, alho em pó, pimenta em pó e realçador glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "206", portion: "84", dv: "4" },
          carbs: { p100: "29", portion: "12", dv: "4" },
          totalSugars: { p100: "0.5", portion: "0.2" },
          addedSugars: { p100: "0.2", portion: "0.1", dv: "0" },
          proteins: { p100: "6.3", portion: "2.5", dv: "5" },
          totalFat: { p100: "7.2", portion: "2.9", dv: "4" },
          saturatedFat: { p100: "3.6", portion: "1.4", dv: "7" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "483", portion: "193", dv: "10" }
        },
        seals: []
      }
    ]
  },
  {
    id: "bolinha-presunto-queijo",
    category: "Salgados",
    product: "Presunto com Queijo",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, requeijão, presunto, farinha de rosca, margarina, queijo mussarela, cebola, sal, caldo de galinha, cebola em pó, alho em pó, pimenta em pó e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "Congelado - 2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "191", portion: "74", dv: "4" },
          carbs: { p100: "29", portion: "11", dv: "4" },
          totalSugars: { p100: "0.5", portion: "0.2" },
          addedSugars: { p100: "0.1", portion: "0", dv: "0" },
          proteins: { p100: "6.7", portion: "2.7", dv: "5" },
          totalFat: { p100: "5.3", portion: "2.1", dv: "3" },
          saturatedFat: { p100: "2.8", portion: "1.1", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "464", portion: "186", dv: "9" }
        },
        seals: []
      },
      {
        package: "Frito-congelado 450g",
        servings: "Cerca de 11",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "222", portion: "89", dv: "4" },
          carbs: { p100: "27", portion: "11", dv: "4" },
          totalSugars: { p100: "0.4", portion: "0.2" },
          addedSugars: { p100: "0.1", portion: "0", dv: "0" },
          proteins: { p100: "6.4", portion: "2.5", dv: "5" },
          totalFat: { p100: "9.8", portion: "3.9", dv: "6" },
          saturatedFat: { p100: "3.4", portion: "1.4", dv: "7" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "442", portion: "177", dv: "9" }
        },
        seals: []
      }
    ]
  },
  {
    id: "bolinha-queijo",
    category: "Salgados",
    product: "Bolinha de Queijo",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, queijo mussarela, requeijão, farinha de rosca, margarina, sal, caldo de galinha e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "208", portion: "80", dv: "4" },
          carbs: { p100: "29", portion: "11", dv: "4" },
          totalSugars: { p100: "0.6", portion: "0.2" },
          addedSugars: { p100: "0.1", portion: "0", dv: "0" },
          proteins: { p100: "6.9", portion: "2.7", dv: "5" },
          totalFat: { p100: "7.1", portion: "2.8", dv: "4" },
          saturatedFat: { p100: "1.6", portion: "4.1", dv: "8" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "461", portion: "184", dv: "9" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "208", portion: "80", dv: "4" },
          carbs: { p100: "29", portion: "11", dv: "4" },
          totalSugars: { p100: "0.6", portion: "0.2" },
          addedSugars: { p100: "0.1", portion: "0", dv: "0" },
          proteins: { p100: "6.9", portion: "2.7", dv: "5" },
          totalFat: { p100: "7.1", portion: "2.8", dv: "4" },
          saturatedFat: { p100: "1.6", portion: "4.1", dv: "8" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "461", portion: "184", dv: "9" }
        },
        seals: []
      },
      {
        package: "Frito-congelado 450g",
        servings: "Cerca de 11",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "233", portion: "96", dv: "5" },
          carbs: { p100: "27", portion: "11", dv: "4" },
          totalSugars: { p100: "0.6", portion: "0.2" },
          addedSugars: { p100: "0.1", portion: "0", dv: "0" },
          proteins: { p100: "6.5", portion: "2.6", dv: "5" },
          totalFat: { p100: "11", portion: "4.6", dv: "7" },
          saturatedFat: { p100: "4.6", portion: "1.9", dv: "10" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "439", portion: "176", dv: "9" }
        },
        seals: []
      }
    ]
  },
  {
    id: "coxinha-frango",
    category: "Salgados",
    product: "Coxinha de Frango",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, frango, requeijão, farinha de rosca, margarina, cebola, molho de tomate, sal, ketchup, caldo de galinha, cheiro verde, flocos de batata, cebola em pó, alho em pó, pimenta em pó, colorau e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "186", portion: "76", dv: "4" },
          carbs: { p100: "29", portion: "12", dv: "4" },
          totalSugars: { p100: "0.5", portion: "0.2" },
          addedSugars: { p100: "0.2", portion: "0.1", dv: "0" },
          proteins: { p100: "7.2", portion: "2.9", dv: "6" },
          totalFat: { p100: "4.6", portion: "1.8", dv: "3" },
          saturatedFat: { p100: "2.3", portion: "0.9", dv: "5" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "454", portion: "182", dv: "9" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "186", portion: "76", dv: "4" },
          carbs: { p100: "29", portion: "12", dv: "4" },
          totalSugars: { p100: "0.5", portion: "0.2" },
          addedSugars: { p100: "0.2", portion: "0.1", dv: "0" },
          proteins: { p100: "7.2", portion: "2.9", dv: "6" },
          totalFat: { p100: "4.6", portion: "1.8", dv: "3" },
          saturatedFat: { p100: "2.3", portion: "0.9", dv: "5" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "454", portion: "182", dv: "9" }
        },
        seals: []
      },
      {
        package: "Frito-congelado 450g",
        servings: "Cerca de 11",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "218", portion: "88", dv: "4" },
          carbs: { p100: "27", portion: "11", dv: "4" },
          totalSugars: { p100: "0.5", portion: "0.2" },
          addedSugars: { p100: "0.2", portion: "0.1", dv: "0" },
          proteins: { p100: "6.9", portion: "2.7", dv: "5" },
          totalFat: { p100: "9.2", portion: "3.7", dv: "6" },
          saturatedFat: { p100: "2.9", portion: "1.2", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1", portion: "0.4", dv: "2" },
          sodium: { p100: "433", portion: "173", dv: "9" }
        },
        seals: []
      }
    ]
  },
  {
    id: "croquete-carne",
    category: "Salgados",
    product: "Croquete de Carne",
    ingredients: "Farinha de trigo enriquecida com ferro e ácido fólico, água, carne moída, cebola, farinha de rosca, margarina, sal, caldo de carne, cebola em pó, alho em pó, pimenta em pó e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "204", portion: "81", dv: "4" },
          carbs: { p100: "35", portion: "14", dv: "5" },
          totalSugars: { p100: "0.6", portion: "0.2" },
          addedSugars: { p100: "0.3", portion: "0.1", dv: "0" },
          proteins: { p100: "6.3", portion: "2.5", dv: "5" },
          totalFat: { p100: "4.3", portion: "1.7", dv: "3" },
          saturatedFat: { p100: "1.9", portion: "0.8", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.5", portion: "0.6", dv: "2" },
          sodium: { p100: "474", portion: "190", dv: "10" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "204", portion: "81", dv: "4" },
          carbs: { p100: "35", portion: "14", dv: "5" },
          totalSugars: { p100: "0.6", portion: "0.2" },
          addedSugars: { p100: "0.3", portion: "0.1", dv: "0" },
          proteins: { p100: "6.3", portion: "2.5", dv: "5" },
          totalFat: { p100: "4.3", portion: "1.7", dv: "3" },
          saturatedFat: { p100: "1.9", portion: "0.8", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.5", portion: "0.6", dv: "2" },
          sodium: { p100: "474", portion: "190", dv: "10" }
        },
        seals: []
      }
    ]
  },
  {
    id: "esfiha-carne",
    category: "Salgados",
    product: "Esfirra de Carne",
    ingredients: "Farinha de trigo enriquecida com ferro e ácido fólico, carne, leite, óleo de soja, água, ovo, cebola, tomate, açúcar, flocos de batata, caldo de carne, sal, fermento biológico, cheiro verde, cebola em pó, alho em pó, pimenta em pó e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM OVO, LEITE E DERIVADOS E DERIVADOS DE TRIGO E DE SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "263", portion: "106", dv: "5" },
          carbs: { p100: "35", portion: "14", dv: "5" },
          totalSugars: { p100: "2.9", portion: "1.2" },
          addedSugars: { p100: "1.9", portion: "0.7", dv: "1" },
          proteins: { p100: "9", portion: "3.6", dv: "7" },
          totalFat: { p100: "9.7", portion: "3.9", dv: "6" },
          saturatedFat: { p100: "1.9", portion: "0.8", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.5", portion: "0.6", dv: "2" },
          sodium: { p100: "226", portion: "90", dv: "5" }
        },
        seals: []
      }
    ]
  },
  {
    id: "esfiha-frango",
    category: "Salgados",
    product: "Esfirra de Frango com requeijão",
    ingredients: "Farinha de trigo enriquecida com ferro e ácido fólico, frango, requeijão, leite, óleo de soja, água, ovo, sal, cebola, açúcar, molho de tomate, ketchup, fermento biológico, cheiro verde, flocos de batata, cebola em pó, alho em pó, pimenta em pó, colorau e realçador de glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM OVO, LEITE E DERIVADOS E DERIVADOS DE TRIGO E DE SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "283", portion: "114", dv: "6" },
          carbs: { p100: "35", portion: "14", dv: "5" },
          totalSugars: { p100: "3.1", portion: "1.2" },
          addedSugars: { p100: "2.1", portion: "0.8", dv: "2" },
          proteins: { p100: "11", portion: "4.3", dv: "9" },
          totalFat: { p100: "11", portion: "4.5", dv: "7" },
          saturatedFat: { p100: "3", portion: "1.2", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.3", portion: "0.5", dv: "2" },
          sodium: { p100: "378", portion: "151", dv: "8" }
        },
        seals: []
      }
    ]
  },
  {
    id: "kibe",
    category: "Salgados",
    product: "Kibe",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, carne moída, margarina, sal, caldo de carne, cebola em pó, alho em pó, pimenta em pó, hortelã e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "202", portion: "79", dv: "4" },
          carbs: { p100: "31", portion: "12", dv: "4" },
          totalSugars: { p100: "0.4", portion: "0.2" },
          addedSugars: { p100: "0.2", portion: "0.1", dv: "0" },
          proteins: { p100: "6.4", portion: "2.5", dv: "5" },
          totalFat: { p100: "5.8", portion: "2.3", dv: "4" },
          saturatedFat: { p100: "2.6", portion: "1.1", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.5", portion: "0.6", dv: "2" },
          sodium: { p100: "421", portion: "169", dv: "8" }
        },
        seals: []
      },
      {
        package: "Frito-congelado 450g",
        servings: "Cerca de 11",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "202", portion: "79", dv: "4" },
          carbs: { p100: "31", portion: "12", dv: "4" },
          totalSugars: { p100: "0.4", portion: "0.2" },
          addedSugars: { p100: "0.2", portion: "0.1", dv: "0" },
          proteins: { p100: "6.4", portion: "2.5", dv: "5" },
          totalFat: { p100: "5.8", portion: "2.3", dv: "4" },
          saturatedFat: { p100: "2.6", portion: "1.1", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.5", portion: "0.6", dv: "2" },
          sodium: { p100: "421", portion: "169", dv: "8" }
        },
        seals: []
      }
    ]
  },
  {
    id: "pastel-carne",
    category: "Salgados",
    product: "Pastel de Carne",
    ingredients: "Massa de pastel pronta (farinha de trigo enriquecida com ferro e ácido fólico, água, óleo de soja, sal, gordura de suíno, realçador de sabor glutamato monossódico e conservante sorbato de potássio), carne moída, cebola, pimentão, cheiro verde, flocos de batata, vinagre e pimenta. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE SOJA E TRIGO.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "232", portion: "96", dv: "5" },
          carbs: { p100: "41", portion: "17", dv: "6" },
          totalSugars: { p100: "1.3", portion: "0.5" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "8.7", portion: "3.5", dv: "7" },
          totalFat: { p100: "3.7", portion: "1.5", dv: "2" },
          saturatedFat: { p100: "1.4", portion: "0.6", dv: "3" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "2", portion: "0.8", dv: "3" },
          sodium: { p100: "522", portion: "209", dv: "10" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "232", portion: "96", dv: "5" },
          carbs: { p100: "41", portion: "17", dv: "6" },
          totalSugars: { p100: "1.3", portion: "0.5" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "8.7", portion: "3.5", dv: "7" },
          totalFat: { p100: "3.7", portion: "1.5", dv: "2" },
          saturatedFat: { p100: "1.4", portion: "0.6", dv: "3" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "2", portion: "0.8", dv: "3" },
          sodium: { p100: "522", portion: "209", dv: "10" }
        },
        seals: []
      }
    ]
  },
  {
    id: "pastel-queijo",
    category: "Salgados",
    product: "Pastel de Queijo",
    ingredients: "Massa de pastel pronta (farinha de trigo enriquecida com ferro e ácido fólico, água, óleo de soja, sal, gordura de suíno, realçador de sabor glutamato monossódico e conservante sorbato de potássio), queijo mussarela, requeijão, cebola em pó, alho em pó, pimenta em pó, orégano e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE SOJA, TRIGO E LEITE. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "260", portion: "105", dv: "5" },
          carbs: { p100: "42", portion: "17", dv: "6" },
          totalSugars: { p100: "1.7", portion: "0.7" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "8.7", portion: "3.5", dv: "7" },
          totalFat: { p100: "6.4", portion: "2.6", dv: "4" },
          saturatedFat: { p100: "4.6", portion: "1.8", dv: "9" },
          transFat: { p100: "2.6", portion: "1.1", dv: "55" },
          fiber: { p100: "1.8", portion: "0.7", dv: "3" },
          sodium: { p100: "534", portion: "213", dv: "11" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "260", portion: "105", dv: "5" },
          carbs: { p100: "42", portion: "17", dv: "6" },
          totalSugars: { p100: "1.7", portion: "0.7" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "8.7", portion: "3.5", dv: "7" },
          totalFat: { p100: "6.4", portion: "2.6", dv: "4" },
          saturatedFat: { p100: "4.6", portion: "1.8", dv: "9" },
          transFat: { p100: "2.6", portion: "1.1", dv: "55" },
          fiber: { p100: "1.8", portion: "0.7", dv: "3" },
          sodium: { p100: "534", portion: "213", dv: "11" }
        },
        seals: []
      }
    ]
  },

  // --- MASSAS ---
  {
    id: "nhoque-4-queijos",
    category: "Massas",
    product: "Nhoque 4 Queijos",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, fécula de mandioca, margarina, queijo mussarela, requeijão, provolone, parmesão, sal, caldo de galinha e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, SOJA E TRIGO. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "20",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "209", portion: "209", dv: "10" },
          carbs: { p100: "37", portion: "37", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.4", portion: "5.4", dv: "11" },
          totalFat: { p100: "4.4", portion: "4.4", dv: "7" },
          saturatedFat: { p100: "1.7", portion: "1.7", dv: "9" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "466", portion: "466", dv: "23" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "100",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "209", portion: "209", dv: "10" },
          carbs: { p100: "37", portion: "37", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.4", portion: "5.4", dv: "11" },
          totalFat: { p100: "4.4", portion: "4.4", dv: "7" },
          saturatedFat: { p100: "1.7", portion: "1.7", dv: "9" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "466", portion: "466", dv: "23" }
        },
        seals: []
      },
      {
        package: "460g",
        servings: "Cerca de 5",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "209", portion: "209", dv: "10" },
          carbs: { p100: "37", portion: "37", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.4", portion: "5.4", dv: "11" },
          totalFat: { p100: "4.4", portion: "4.4", dv: "7" },
          saturatedFat: { p100: "1.7", portion: "1.7", dv: "9" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "466", portion: "466", dv: "23" }
        },
        seals: []
      },
      {
        package: "500g",
        servings: "5",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "209", portion: "209", dv: "10" },
          carbs: { p100: "37", portion: "37", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.4", portion: "5.4", dv: "11" },
          totalFat: { p100: "4.4", portion: "4.4", dv: "7" },
          saturatedFat: { p100: "1.7", portion: "1.7", dv: "9" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "466", portion: "466", dv: "23" }
        },
        seals: []
      }
    ]
  },
  {
    id: "nhoque-mandioca",
    category: "Massas",
    product: "Nhoque de Mandioca",
    ingredients: "Farinha de trigo enriquecida com ferro e ácido fólico, água, fécula de mandioca, margarina, caldo de galinha, sal e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE TRIGO, LEITE E SOJA. PODE CONTER CENTEIO, CEVADA E AVEIA.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "20",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "206", portion: "206", dv: "10" },
          carbs: { p100: "39", portion: "39", dv: "13" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "4.7", portion: "4.7", dv: "9" },
          totalFat: { p100: "3.5", portion: "3.5", dv: "5" },
          saturatedFat: { p100: "1", portion: "1", dv: "5" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.2", portion: "1.2", dv: "5" },
          sodium: { p100: "457", portion: "457", dv: "23" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "100",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "206", portion: "206", dv: "10" },
          carbs: { p100: "39", portion: "39", dv: "13" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "4.7", portion: "4.7", dv: "9" },
          totalFat: { p100: "3.5", portion: "3.5", dv: "5" },
          saturatedFat: { p100: "1", portion: "1", dv: "5" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.2", portion: "1.2", dv: "5" },
          sodium: { p100: "457", portion: "457", dv: "23" }
        },
        seals: []
      }
    ]
  },
  {
    id: "nhoque-presunto-queijo",
    category: "Massas",
    product: "Nhoque de Presunto com Queijo",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, fécula de mandioca, margarina, presunto, requeijão, queijo mussarela, sal, caldo de galinha, cebola em pó, alho em pó, pimenta em pó, orégano e realçador de sabor glutamato monossódico. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, SOJA E TRIGO. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "20",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "204", portion: "204", dv: "10" },
          carbs: { p100: "36", portion: "36", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.5", portion: "5.5", dv: "11" },
          totalFat: { p100: "4.2", portion: "4.2", dv: "6" },
          saturatedFat: { p100: "1.6", portion: "1.6", dv: "8" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "473", portion: "473", dv: "24" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "100",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "204", portion: "204", dv: "10" },
          carbs: { p100: "36", portion: "36", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.5", portion: "5.5", dv: "11" },
          totalFat: { p100: "4.2", portion: "4.2", dv: "6" },
          saturatedFat: { p100: "1.6", portion: "1.6", dv: "8" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "473", portion: "473", dv: "24" }
        },
        seals: []
      },
      {
        package: "500g",
        servings: "5",
        portionSize: "100 g",
        homeMeasure: "1 prato",
        table: {
          energy: { p100: "204", portion: "204", dv: "10" },
          carbs: { p100: "36", portion: "36", dv: "12" },
          totalSugars: { p100: "0", portion: "0" },
          addedSugars: { p100: "0", portion: "0", dv: "0" },
          proteins: { p100: "5.5", portion: "5.5", dv: "11" },
          totalFat: { p100: "4.2", portion: "4.2", dv: "6" },
          saturatedFat: { p100: "1.6", portion: "1.6", dv: "8" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.1", portion: "1.1", dv: "4" },
          sodium: { p100: "473", portion: "473", dv: "24" }
        },
        seals: []
      }
    ]
  },

  // --- DOCES ---
  {
    id: "brigadeiro-tradicional",
    category: "Doces",
    product: "Brigadeiro Tradicional",
    ingredients: "Leite condensado, granulado de chocolate, creme de leite, chocolate em pó 50% cacau, margarina e xarope de glucose de milho. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM LEITE E DERIVADOS E DERIVADOS DE SOJA. PODE CONTER AVEIA, CENTEIO, CEVADA, OVOS E TRIGO. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "Bandeja 25un",
        servings: "Cerca de 13",
        portionSize: "25 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "382", portion: "97", dv: "5" },
          carbs: { p100: "58", portion: "15", dv: "5" },
          totalSugars: { p100: "56", portion: "14" },
          addedSugars: { p100: "48", portion: "12", dv: "24" },
          proteins: { p100: "5.9", portion: "1.5", dv: "3" },
          totalFat: { p100: "14", portion: "3.4", dv: "5" },
          saturatedFat: { p100: "9.1", portion: "2.3", dv: "11" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "2", portion: "0.5", dv: "2" },
          sodium: { p100: "121", portion: "30", dv: "2" }
        },
        seals: ["AÇÚCAR ADICIONADO", "GORDURA SATURADA"]
      }
    ]
  },
  {
    id: "churros-chocolate",
    category: "Doces",
    product: "Churros de Chocolate",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, recheio de chocolate (água, leite, açúcar, soro de leite, leite em pó, glicose, amido modificado, cacau em pó, sal, espessante pectina e estabilizante citrato de sódio), açúcar, farinha de rosca, margarina e extrato de baunilha. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "246", portion: "98", dv: "5" },
          carbs: { p100: "48", portion: "19", dv: "6" },
          totalSugars: { p100: "23", portion: "9.3" },
          addedSugars: { p100: "22", portion: "8.8", dv: "18" },
          proteins: { p100: "4.6", portion: "1.8", dv: "4" },
          totalFat: { p100: "3.9", portion: "1.6", dv: "2" },
          saturatedFat: { p100: "2", portion: "0.8", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.2", portion: "0.5" , dv: "2" },
          sodium: { p100: "33", portion: "13", dv: "1" }
        },
        seals: ["AÇÚCAR ADICIONADO"]
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "246", portion: "98", dv: "5" },
          carbs: { p100: "48", portion: "19", dv: "6" },
          totalSugars: { p100: "23", portion: "9.3" },
          addedSugars: { p100: "22", portion: "8.8", dv: "18" },
          proteins: { p100: "4.6", portion: "1.8", dv: "4" },
          totalFat: { p100: "3.9", portion: "1.6", dv: "2" },
          saturatedFat: { p100: "2", portion: "0.8", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "1.2", portion: "0.5", dv: "2" },
          sodium: { p100: "33", portion: "13", dv: "1" }
        },
        seals: ["AÇÚCAR ADICIONADO"]
      }
    ]
  },
  {
    id: "churros-doce-leite",
    category: "Doces",
    product: "Churros de Doce de Leite",
    ingredients: "Água, farinha de trigo enriquecida com ferro e ácido fólico, doce de leite, açúcar, farinha de rosca, margarina e extrato de baunilha. CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM DERIVADOS DE LEITE, TRIGO E SOJA. CONTÉM LACTOSE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "248", portion: "101", dv: "5" },
          carbs: { p100: "49", portion: "20", dv: "7" },
          totalSugars: { p100: "23", portion: "9.2" },
          addedSugars: { p100: "21", portion: "8.5", dv: "17" },
          proteins: { p100: "4.5", portion: "1.8", dv: "4" },
          totalFat: { p100: "3.8", portion: "1.5", dv: "2" },
          saturatedFat: { p100: "1.8", portion: "0.7", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "0.9", portion: "0.4", dv: "2" },
          sodium: { p100: "46", portion: "18", dv: "1" }
        },
        seals: ["AÇÚCAR ADICIONADO"]
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "248", portion: "101", dv: "5" },
          carbs: { p100: "49", portion: "20", dv: "7" },
          totalSugars: { p100: "23", portion: "9.2" },
          addedSugars: { p100: "21", portion: "8.5", dv: "17" },
          proteins: { p100: "4.5", portion: "1.8", dv: "4" },
          totalFat: { p100: "3.8", portion: "1.5", dv: "2" },
          saturatedFat: { p100: "1.8", portion: "0.7", dv: "4" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "0.9", portion: "0.4", dv: "2" },
          sodium: { p100: "46", portion: "18", dv: "1" }
        },
        seals: ["AÇÚCAR ADICIONADO"]
      },
      {
        package: "Frito-congelado 450g",
        servings: "Cerca de 11",
        portionSize: "40 g",
        homeMeasure: "2 unidades",
        table: {
          energy: { p100: "281", portion: "113", dv: "6" },
          carbs: { p100: "47", portion: "19", dv: "6" },
          totalSugars: { p100: "22", portion: "8.8" },
          addedSugars: { p100: "20", portion: "8.1", dv: "16" },
          proteins: { p100: "4.3", portion: "1.7", dv: "3" },
          totalFat: { p100: "8.4", portion: "3.3", dv: "5" },
          saturatedFat: { p100: "2.4", portion: "1", dv: "5" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "0.9", portion: "0.4", dv: "2" },
          sodium: { p100: "44", portion: "17", dv: "1" }
        },
        seals: ["AÇÚCAR ADICIONADO"]
      }
    ]
  },
  {
    id: "pastel-pacoca",
    category: "Doces",
    product: "Pastel de Paçoca",
    ingredients: "Massa de pastel pronta (farinha de trigo enriquecida com ferro e ácido fólico, água, óleo de soja, sal, gordura de suíno, realçador de sabor glutamato monossódico e conservante sorbato de potássio) e recheio de paçoca (amendoim, açúcar, gordura vegetal, farinha de soja, sal, emulsificante lecitina de soja, aromatizante e antioxidante butil hidroquinona terciária). CONTÉM GLÚTEN.",
    allergens: "ALÉRGICOS: CONTÉM AMENDOIM E DERIVADOS DE SOJA E TRIGO. PODE CONTER AMENDOAS, AVELA, CASTANHA-DE-CAJU, CASTANHA-DO-PARÁ, CEVADA E LEITE.",
    nutritionist: "Consuquality, CNPJ: 27.623.968/0001-20",
    variations: [
      {
        package: "2 kg",
        servings: "50",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "347", portion: "137", dv: "7" },
          carbs: { p100: "51", portion: "20", dv: "7" },
          totalSugars: { p100: "10", portion: "4.1" },
          addedSugars: { p100: "8.2", portion: "3.3", dv: "7" },
          proteins: { p100: "8.7", portion: "3.5", dv: "7" },
          totalFat: { p100: "12", portion: "4.8", dv: "7" },
          saturatedFat: { p100: "3.1", portion: "1.2", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "2.9", portion: "1.2", dv: "5" },
          sodium: { p100: "437", portion: "175", dv: "9" }
        },
        seals: []
      },
      {
        package: "10 kg",
        servings: "250",
        portionSize: "40 g",
        homeMeasure: "1 unidade",
        table: {
          energy: { p100: "347", portion: "137", dv: "7" },
          carbs: { p100: "51", portion: "20", dv: "7" },
          totalSugars: { p100: "10", portion: "4.1" },
          addedSugars: { p100: "8.2", portion: "3.3", dv: "7" },
          proteins: { p100: "8.7", portion: "3.5", dv: "7" },
          totalFat: { p100: "12", portion: "4.8", dv: "7" },
          saturatedFat: { p100: "3.1", portion: "1.2", dv: "6" },
          transFat: { p100: "0", portion: "0", dv: null },
          fiber: { p100: "2.9", portion: "1.2", dv: "5" },
          sodium: { p100: "437", portion: "175", dv: "9" }
        },
        seals: []
      }
    ]
  }
];